var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-inline mb-2"},[_c('label',{staticClass:"mr-sm-2"},[_vm._v("Sort by")]),_c('b-form-select',{attrs:{"size":"sm","options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }